import { Component, OnInit } from '@angular/core';
import { GruposService } from 'src/app/services/grupos.service';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-mi-grupo',
  templateUrl: './mi-grupo.component.html',
  styleUrls: ['./mi-grupo.component.scss']
})
export class MiGrupoComponent implements OnInit {
  data;
  respuestaDatosGrupo:any;
  respuestaGet:any;
  datosCliente;
  clienteid;
  datosGrupo;
  enviroment = environment.BASE_URL;

  constructor(private _getDatosGrupo:GruposService, private _get:LoginService) { }

  ngOnInit(): void {
    this.getDataCliente();
  }

  getDataCliente(){
    console.log('entraaaaa');
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          this.clienteid = this.datosCliente.id;
          this.getDatosGrupo(this.datosCliente.grupo)
          // alert(this.datosCliente.grupo);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

  getDatosGrupo(grupo){
    this.data = {
      'grupo':grupo
    }

    this._getDatosGrupo.getDatosGrupo(this.data).subscribe(
      data => {
        this.respuestaDatosGrupo = data;
        if(this.respuestaDatosGrupo.success){
          this.datosGrupo = this.respuestaDatosGrupo.content;
          document.getElementById('click2').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

}
